// removed by extract-text-webpack-plugin
module.exports = {"orderItemSummary":"Gdaeb28 G2f6568 Gd71c60"};